export const en = {
  en: {
    faqs: 'faqs'
  }
}
